import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import Amplify from 'aws-amplify'
import config from './aws-exports'

Amplify.configure({
    ...config,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
})

const render = (Component: React.ComponentType) => {
    ReactDOM.render(<Component />, document.getElementById('root'))
}

render(App)

if (module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default
        render(NextApp)
    })
}
